import { instance } from '@payments-checkout/shared/helpers/service/instance.service';
import { UseMutationOptions, useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { CustomerSessionDataProps } from '../../types/customer.types';

export async function setCustomerData({
  paymentLinkId,
  sessionId,
  customerData,
}: CustomerSessionDataProps) {
  const response = await instance.post(
    `paymentlinks/${paymentLinkId}/sessions/${sessionId}/customer`,
    customerData
  );
  return response.data;
}

type useCustomerDataOptions = Omit<
  UseMutationOptions<unknown, AxiosError, CustomerSessionDataProps>,
  'mutationFn'
>;

export const useCustomerData = (options?: useCustomerDataOptions) => {
  return useMutation({
    ...options,
    mutationFn: ({ customerData, paymentLinkId, sessionId }) =>
      setCustomerData({ paymentLinkId, sessionId, customerData }),
  });
};
